<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCardHeader  class="p-1">
          <CRow>
            <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

              <strong >{{$t('importExportData')}}</strong>

            </CCol>
            <CCol col="4" style="text-align: end">



            </CCol>
          </CRow>
        </CCardHeader>

        <CRow>

          <CCol col="4">
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                    <strong>{{$t('export')}}</strong>
                  </CCol>

                </CRow>
              </CCardHeader>

              <CCardBody>
                <CRow>
                  <CCol>
<!--                    <CButton-->
<!--                        size="sm"-->
<!--                        class="m-1"-->
<!--                        color="secondary">{{ $t("ImportData") }}-->
<!--                    </CButton>-->
                  </CCol>
                  <CCol>
                    <CDropdown
                        size="sm"
                        class="m-1"

                        color="secondary"
                        :toggler-text="$t('ExportData')"
                    >
                      <CDropdownItem @click="get_customers()">{{ $t("Customers") }}</CDropdownItem>
                      <CDropdownDivider></CDropdownDivider>

                      <CDropdownItem @click="get_vendors()">{{ $t("Suppliers") }}</CDropdownItem>
                      <CDropdownDivider></CDropdownDivider>

                      <CDropdownItem @click="get_users(1)">{{ $t("Personals") }}</CDropdownItem>
                      <CDropdownDivider>
                      </CDropdownDivider>

                      <CDropdownItem @click="get_users(2)">{{$t('persons')}}</CDropdownItem>
                      <CDropdownDivider>
                      </CDropdownDivider>
                      <CDropdownItem @click="get_lists_groups()">{{ $t("ChartAccount") }}</CDropdownItem>
                      <CDropdownDivider>
                      </CDropdownDivider>
                      <CDropdownItem @click="get_products()">{{ $t("items") }}</CDropdownItem>
                    </CDropdown>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
          <CCol col="4">
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                    <strong>{{$t('import')}}</strong>
                  </CCol>

                </CRow>
              </CCardHeader>

              <CCardBody>
                <CRow>
                  <CCol>
<!--                    <CButton-->
<!--                        size="sm"-->
<!--                        class="m-1"-->
<!--                        color="secondary">{{ $t("ImportData") }}-->
<!--                    </CButton>-->
                  </CCol>
                  <CCol>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
<!--          <CCol col="4">-->
<!--            <CCard>-->
<!--              <CCardHeader>-->
<!--                <CRow>-->
<!--                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">-->
<!--                    <strong>{{ $t("Backup") }}</strong>-->
<!--                  </CCol>-->
<!--                  <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">-->
<!--                    <CIcon name="cil-save"/>-->
<!--                  </CCol>-->
<!--                </CRow>-->
<!--              </CCardHeader>-->
<!--              <CCardBody>-->
<!--                <CButton-->
<!--                    size="sm"-->
<!--                    class="m-1"-->

<!--                    color="secondary">{{ $t("BackupData") }}-->
<!--                </CButton>-->
<!--                <CButton-->
<!--                    size="sm"-->
<!--                    class="m-1"-->

<!--                    color="secondary">{{ $t("RestoreData") }}-->
<!--                </CButton>-->
<!--                <CButton-->
<!--                    size="sm"-->
<!--                    class="m-1"-->

<!--                    color="secondary">{{ $t("ResetAllData") }}-->
<!--                </CButton>-->
<!--                <CSelect-->
<!--                    :label="$t('AutoBackup')"-->
<!--                    :options="[{label:$i18n.t('active'),value:1},{label:$i18n.t('deactivate'),value:2}]"-->
<!--                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"-->
<!--                />-->
<!--                <CInput-->
<!--                    :label="$t('BackupSchedule')"-->
<!--                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"-->
<!--                />-->
<!--                <CInput-->
<!--                    :label="$t('BackupDirectory')"-->
<!--                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"-->
<!--                />-->

<!--              </CCardBody>-->
<!--            </CCard>-->

<!--          </CCol>-->

        </CRow>

      </CCol>
    </CRow>
    <CModal
        :show.sync="export_modal"
        :no-close-on-backdrop="false"
        color="transparent"
        border-color="primary"
        :title="$t('ExportData')"
    >
      <download-excel :data="json_data"
      :name="export_file_name"
                      @click.native="export_modal=false"
      >
      <CButton color="secondary">
        {{$t('DownloadExcel')}}

      </CButton>
      </download-excel>


      <template #footer>

        <CButton
            @click="export_modal = false"
            color="success"
        >{{$t("buttons.cancel")}}
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];

import Vue from "vue";
import JsonExcel from "vue-excel-ultra";

Vue.component("downloadExcel", JsonExcel);
export default {
  name: 'Login',
  components:{
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      name: '',
      file: null,
      export_file_name:'',
      color: '#ffffff',
      code: '',
      previewImage: '/img/placeholder.png',
      description: '',
      phone_objects: [{phone_type: 19, phone: '', row_id: 1}],
      export_modal:false,
      json_data:[],
      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:30%'},
        {key: 'branchTitle', label: this.$t('tables.name'), _style: 'width:70%'},
        // {key: 'provinceTitle', label: this.$t('tables.province'), _style: 'width:10%'},
        // {key: 'cityTitle', label: this.$t('tables.city'), _style: 'width:10%;'},
        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],
      details: [],
      collapseDuration: 0,
      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    this.get_lists();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    }
  },
  methods: {
    get_customers() {
      var self = this;


      const formData = new FormData();

      var url = "GetFullPersons";
      formData.append('IsVendor', false);
      formData.append('IsWorker', false);
      formData.append('IsCustomer', true);
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.export_file_name="customers.xls"
        self.export_modal = true;
        var received_data = [];
        self.json_data = [];
          received_data = response.data.data.filter(item => item.isCustomer);
          // received_data = received_data.map((item, row) => {
          //   return {...item, row}
          // });
          // received_data.forEach((val) => {
          //   var obj = {id: val.row+1, Mobile: val.mobileNo,
          //   Name:val.userName}
          //   self.json_data.push(val);
          // });
            var pros = [];
            received_data.forEach(function (val) {
                pros.push({
                    "Customer Code":val.personCode,
                    "Title":val.title,
                    "Name":val.userName,
                    "Middle Name":val.catTitle,
                    "Surname":val.surName,
                    "Type":val.brandName,
                    "Group Name":val.groupName,
                    "Job Profile":val.jobProfile,
                    "Vat No":val.exitTypeTitle,
                    "Company Reg No":val.saleVAT,
                    "Bill Address":val.purchasePrice,
                    "Delivery Address":val.customerPrice,
                    "County":val.wholesalePrice,
                    "City":val.shopPrice,
                    "Town":val.wholesaleDiscount,
                    "District":val.partnerDiscount,
                    "Postcode":val.partnerDiscount,
                    "Country":val.partnerDiscount,
                    "Shop No":val.partnerDiscount,
                    "Mobile No":val.mobileNo,
                    "Email":val.email,
                    "Website":val.partnerDiscount,

                })
            })
            //     "purchaceVAT":val.purchaceVAT,
            //     "summary":val.summary,
            //     "partnerPrice":val.partnerPrice,

            self.json_data = pros
            self.export_modal = true;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_vendors() {
      var self = this;


      const formData = new FormData();


      var url = "GetFullPersons";
      formData.append('IsVendor', true);
      formData.append('IsWorker', false);
      formData.append('IsCustomer', false);
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.export_file_name="Suppliers.xls"

          self.export_modal = true;
        var received_data = [];
        self.json_data = [];
          received_data = response.data.data.filter(item => item.isVendor);
          // received_data = received_data.map((item, row) => {
          //   return {...item, row}
          // });
          // received_data.forEach((val) => {
          //   var obj = {id: val.row+1, Mobile: val.mobileNo,
          //   Name:val.userName}
          //   self.json_data.push(val);
          // });
            var pros = [];
            received_data.forEach(function (val) {
                pros.push({
                    "Supplier Code":val.personCode,
                    "Title":val.title,
                    "Name":val.userName,
                    "Surname":val.surName,
                    "Type":val.brandName,
                    "Category":val.brandName,
                    "Vat No":val.exitTypeTitle,
                    "Company Reg No":val.saleVAT,
                    "Bill Address":val.purchasePrice,
                    "Delivery Address":val.customerPrice,
                    "County":val.wholesalePrice,
                    "City":val.shopPrice,
                    "Town":val.wholesaleDiscount,
                    "District":val.partnerDiscount,
                    "Postcode":val.partnerDiscount,
                    "Country":val.partnerDiscount,
                    "Office No":val.partnerDiscount,
                    "Mobile No":val.mobileNo,
                    "Email":val.email,
                    "Website":val.partnerDiscount,

                })
            })
            self.json_data = pros
            self.export_modal = true;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_users(type) {
      var self = this;


      const formData = new FormData();

      var url = "GetFullPersons";
      if(type==1){//personals
        formData.append('IsVendor', false);
        formData.append('IsWorker', true);
        formData.append('IsCustomer', false);

      }
      if(type==2){//persons
        formData.append('IsVendor', false);
        formData.append('IsWorker', false);
        formData.append('IsCustomer', false);

      }
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.export_file_name="Users.xls"

          self.export_modal = true;
        var received_data = [];
        self.json_data = [];
          received_data = response.data.data.filter(item => item.isWorker);
          // received_data = received_data.map((item, row) => {
          //   return {...item, row}
          // });
          // received_data.forEach((val) => {
          //   var obj = {id: val.row+1, Mobile: val.mobileNo,
          //   Name:val.userName}
            // self.json_data.push(val);
          // });

            var pros = [];
           if(type==1){//personals
               received_data.forEach(function (val) {
                   pros.push({
                       "Personnel Code":val.productCode,
                       "Title":val.productName,
                       "Name":val.productUnitName,
                       "Middle Name":val.catTitle,
                       "Surname":val.maintenanceTitle,
                       "D.O.B":val.brandName,
                       "Branch":val.exitTypeTitle,
                       "Department":val.saleVAT,
                       "Job Title":val.purchasePrice,
                       "NINO":val.customerPrice,
                       "Home No":val.wholesalePrice,
                       "Mobile No":val.wholesalePrice,
                       "Address":val.shopPrice,
                       "Email":val.wholesaleDiscount,
                       "Employment Date":val.partnerDiscount,
                       "Leavers Date":val.partnerDiscount,

                   })
               })
           }
           if(type==2){//persons
               received_data.forEach(function (val) {
                   pros.push({
                       "Person Code":val.productCode,
                       "Title":val.productName,
                       "Name":val.productUnitName,
                       "Middle Name":val.catTitle,
                       "Surname":val.maintenanceTitle,
                       "Type":val.brandName,
                       "Organization":val.exitTypeTitle,
                       "Department":val.saleVAT,
                       "Job Title":val.purchasePrice,
                       "Office No":val.customerPrice,
                       "Mobile No":val.wholesalePrice,
                       "Address":val.shopPrice,
                       "Email":val.wholesaleDiscount,
                       "Website":val.partnerDiscount,

                   })
               })
           }

            //     "purchaceVAT":val.purchaceVAT,
            //     "summary":val.summary,
            //     "partnerPrice":val.partnerPrice,

            self.json_data = pros
            self.export_modal = true;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_lists_groups() {
      var self = this;

      const formData = new FormData();
      var url = "Get_AllAccountingGroups";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);
      self.data_accounting = [];
      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {
              self.export_file_name="Charts.xls"


                response.data.data.forEach((val) => {
                    if (val.accNature == 1) {
                        val.nature = self.$t('debtor');
                    }
                    if (val.accNature == 2) {
                        val.nature = self.$t('creditor');
                    }
                    if (val.accNature == 3) {
                        val.nature = self.$t('neutral');
                    }
                    if (val.accNature == 0) {
                        val.nature = '';
                    }

                    if (val.accType == 1) {
                        val.type = self.$t('permanent');
                    }
                    if (val.accType == 2) {
                        val.type = self.$t('temporary');
                    }
                    if (val.accType == 0) {
                        val.type = '';
                    }
                });
              self.json_data = response.data.data.map((item, row) => {
                return {...item, row}
              });
              self.export_modal = true;


            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },

    get_products() {
      var self = this;

      const formData = new FormData();
      var url = "GetProductsFullInfo";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);
      self.data_accounting = [];
      // formData.append("id", 1);

      axios.get(url, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {
              self.export_file_name="Products.xls"
var pros = [];
                response.data.data.forEach(function (val) {
                    if(val.barCode==null){
                        val.barCode = "";
                    }
                    pros.push({
                        "Item Code":val.productCode,
                        "Item Name":val.productName,
                        "Package / V":val.productUnitName,
                        "Category":val.catTitle,
                        "Type":val.maintenanceTitle,
                        "Brand":val.brandName,
                        "INV Validation":val.exitTypeTitle,
                        "Sale VAT":val.saleVAT,
                        "Purchase Price":val.purchasePrice,
                        "Consumer Price":val.customerPrice,
                        "Delivery Price":val.wholesalePrice,
                        "Collection Price":val.shopPrice,
                        "Delivery Discount":val.wholesaleDiscount,
                        "Collection Discount":val.partnerDiscount,
                        "Order Point":val.orderPoint,
                        "Min Qty":val.existanceQty,
                        "Shelf Life":val.shelfLife,
                        "Stock Qty":val.existanceQty,
                        "Item":val.masterTitle,
                        "Item Id":val.id,
                        "BarCode":val.barCode,
                        "Inventory Code":val.inventoryCode,
                        "Package ID":val.productUnitId,
                        "ID":val.productId,
                        "Main Group":val.productNatureTitle,
                        "Main Group ID":val.productNatureId,
                        "Brand ID":val.brandId,
                        "Category ID":val.catRelId,
                        "INV Valuation ID":val.exitTypeId,
                        "Type ID":val.maintenanceId,
                        "Status ID":val.productStatusId,
                        "Status":val.productStatusTitle,
                        "Base Unit ID":val.unitId,
                        "Base Unit":val.unitName,
                        "Commission":val.commission,
                        "Weight":val.weight,
                        "Length":val.length,
                        "Width":val.width,
                        "Height":val.height,
                        "Specification ID":val.specificationId,
                        "Specification":val.specificationTitle,

                        })
                })
                //     "purchaceVAT":val.purchaceVAT,
                //     "summary":val.summary,
                //     "partnerPrice":val.partnerPrice,

                    self.json_data = pros
              self.export_modal = true;


            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },

    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.color != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      if (this.color == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
      }
      // if (this.description == '') {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      // }
      return false;
      // e.preventDefault();
    },
    get_image_file(item) {
      // console.log("image url is " + item.imageName);
      return this.$root.base_url + item.imageName;
    },
    get_lists() {
      var self = this;

      const formData = new FormData();


      formData.append('id', 0);


      axios.post('GetBranchList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goSubCategories(item, index) {

      this.$router.push({path: '/dashboard/base/categories/' + this.items[index].recId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    goToProductList(item) {
      this.$router.push({path: "/dashboard/products/list-cat/" + item.recId})
      // this.$router.push({ path: '/dashboard/base/categories/'+this.items[index].recId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      this.previewImage = URL.createObjectURL(this.file);
    },
    insert_data() {


      if (!this.validateForm()) {
        // console.log("validate form is false"+this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddMainCat";
      } else {
        url = "EditMainCat";
        formData.append('id', this.status_form)

      }

      formData.append('file', this.file);
      formData.append('MainCatTitle', this.name);
      formData.append('Color', this.color);
      formData.append('Code', this.code);
      if (this.$route.params.cat_id != null) {
        formData.append('IsParent', this.$route.params.cat_id);

      } else {
        formData.append('IsParent', 0);

      }
      formData.append('summary', this.description);
      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.color = '#ffffff';
        self.code = '';
        self.description = '';
        self.previewImage = '/img/placeholder.png';
        self.get_lists();


      })

          // axios.post(  '/admin/category', {
          //     name: self.name,
          //     description: self.description,
          //     image: self.image,
          //     cat: 0,
          // }).then(function (response) {
          //     self.name = '';
          //     self.description = '';
          //     // localStorage.setItem("api_token", response.data.access_token);
          //     // self.$router.push({ path: 'notes' });
          // })
          .catch(function (error) {
            console.log(error);
          });

    }, delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].recId;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteCat";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
          self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {
            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
<style>
.col-form-label {

  font-size: 11px !important;
}
</style>
